// utils/exportProgress.ts
export type Stage =
  | "maintenance"
  | "complementary"
  | "checkups"
  | "rioplans"
  | "writing";

const WEIGHTS: Record<Stage, number> = {
  maintenance: 0.4,
  complementary: 0.25,
  checkups: 0.25,
  rioplans: 0.08,
  writing: 0.02,
};

// calcula progresso total com base no estágio atual e (index/total) do chunk
export function calcProgress(
  stage: Stage,
  index: number,
  total: number
): number {
  // soma dos pesos anteriores
  const stages: Stage[] = [
    "maintenance",
    "complementary",
    "checkups",
    "rioplans",
    "writing",
  ];
  const currentIdx = stages.indexOf(stage);
  const doneWeight = stages
    .slice(0, Math.max(0, currentIdx))
    .reduce((s, st) => s + WEIGHTS[st], 0);

  const ratio = total > 0 ? Math.min(1, Math.max(0, index / total)) : 0;
  const currentWeight = WEIGHTS[stage] ?? 0;

  const pct = (doneWeight + currentWeight * ratio) * 100;
  return Math.max(0, Math.min(100, pct));
}
